import { render, staticRenderFns } from "./cPlashka.vue?vue&type=template&id=a38be026&scoped=true&"
import script from "./cPlashka.vue?vue&type=script&lang=ts&"
export * from "./cPlashka.vue?vue&type=script&lang=ts&"
import style0 from "./cPlashka.vue?vue&type=style&index=0&id=a38be026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38be026",
  null
  
)

export default component.exports